export default [
  {
    name: 'setting-tags',
    path: '/settings/checkin',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Controle de acesso',
      icon: 'dvr',
      label: 'Controle de acesso',
      roles: ['Admin']
    }
  },
  {
    name: 'checkin-lead-form-builder',
    path: '/settings/checkin/lead-form/:id',
    component: () => import(/* webpackChunkName: "event" */ '@/pages/form-builder/Builder.vue'),
    meta: {
      showNavbar: true,
      title: 'Formulário de Coleta de Lead',
      roles: ['Admin']
    }
  }
]
